module.exports = "<div class=\"card\">\r\n    <div class=\"card-block\">\r\n        <div [innerHTML]=\"text | safeHtml\"></div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/components/static-text/static-text.component.html
// module id = ./src/app/authentication/components/static-text/static-text.component.html
// module chunks = main